import { axios } from "utils";

import { ADMIN_FEATURE_FLAG_URL } from "consts";

import {
  FeatBitEnvironmentWithSegments,
  SegmentChangesReport,
  SegmentChangesRequestBody,
  SegmentEntitySearchRequest,
  SegmentEntry,
  SegmentEntryList,
  SegmentListRequest,
} from "models";

// The page shows the API's own reason, so the interceptor's generic toast is suppressed on these calls.

export const getFeatBitSegments = async (): Promise<FeatBitEnvironmentWithSegments[]> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FEATURE_FLAG_URL}/segments`, { hideErrorMessage: true });

export const getSegmentEntries = async ({ envId, segmentId, type }: SegmentListRequest): Promise<SegmentEntryList> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FEATURE_FLAG_URL}/segments/${segmentId}/entries`, { params: { envId, type }, hideErrorMessage: true });

export const searchSegmentEntities = async ({ type, query }: SegmentEntitySearchRequest): Promise<SegmentEntry[]> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FEATURE_FLAG_URL}/entities`, { params: { type, query }, hideErrorMessage: true });

export const applySegmentChanges = async (data: SegmentChangesRequestBody): Promise<SegmentChangesReport> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.put(`${ADMIN_FEATURE_FLAG_URL}/segments/changes`, { data }, { hideErrorMessage: true });
